<template>
  <v-content>
    <v-container fluid>
      <v-layout row wrap align-center justify-center>
        <v-flex xs12 md6>
          <transition name="fadeFast">
            <v-alert
              v-model="error.show"
              color="error"
              icon="warning"
              dismissible
              centered
            >
              {{ error.message }}
            </v-alert>
          </transition>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center justify-center>
        <v-flex xs12 md6>
          <transition name="fadeFast">
            <v-alert
              v-model="form.show"
              color="info"
              icon="report"
              centered
              dark
            >
              Küldtünk egy emailt, amit 5 percen belül megkapsz. <br />
              A levélben találod a PIN kódot, amit ide kell beírnod. <br />
              Ha nem érkezik meg a levél és a Spam mappában sem találod, írj
              nekünk.
            </v-alert>
          </transition>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center justify-center>
        <v-flex d-flex xs12 md6>
          <transition name="fadeFast">
            <v-card class="elevation-12" v-show="form.show">
              <v-toolbar dark color="primary">
                <v-toolbar-title>Regisztráció véglegesítése</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    prepend-icon="more_horiz"
                    name="login"
                    label="PIN kód"
                    type="text"
                    :rules="[rules.required]"
                    v-model="form.pin"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="error"
                  @click="$router.push({ name: 'registration' })"
                >
                  <v-icon left dark>keyboard_arrow_left</v-icon>
                  Vissza
                </v-btn>
                <v-btn color="primary" @click="getRegistrationPIN">
                  Küldés
                  <v-icon right dark>input</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </transition>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center justify-center>
        <v-flex xs12 md6 text-xs-center>
          <transition name="fadeFast">
            <v-card
              v-show="!form.show"
              dark
              class="mb-2 pb-2 pm-2"
              color="success"
            >
              <h1 class="pt-3">
                Sikeres regisztráció
              </h1>
              <br />
              <v-icon x-large center dark class="mb-3"
                >check_circle_outline</v-icon
              >
              <v-spacer></v-spacer>
              <v-btn
                dark
                color="success"
                @click="$router.push({ name: 'home' })"
                class="mb-2"
              >
                Bejelentkezés
                <v-icon right dark>keyboard_arrow_right</v-icon>
              </v-btn>
            </v-card>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    drawer: null,
    form: {
      pin: "",
      show: true
    },
    error: {
      show: false,
      code: "",
      message: ""
    },
    rules: {
      required: value => !!value || "Kötelező"
    }
  }),
  methods: {
    getRegistrationPIN() {
      axios
        .post(this.$store.getters.getApiUrl + "/api/registration/pin", {
          pin: this.$data.form.pin
        })
        .then(response => {
          this.$data.form.show = false;
          this.$data.error.show = false;

          this.$store.commit("loginSuccess", {
            token: response.data.token,
            isLoggedIn: true,
            currentUser: response.data.currentUser
          });

          // this.$router.push({path: '/home'});
        })
        .catch(error => {
          this.$data.error.message = error.response.data.message;
          this.$data.error.code = error.response.data.code;
          this.$data.error.show = true;
        });
    }
  }
};
</script>
